/**
 * The three corner treatments a child of a segmented group box gets. All of them fill the
 * wrapper's 32px border-box; only the end children keep a rounded outside edge, which is
 * WMPCM-8692's "no rounded edge for those buttons in middle".
 *
 * The wrapper deliberately does NOT use `overflow-hidden` to do this. Every group here holds at
 * least one Radix popover trigger, and an `overflow-hidden` ancestor is a clipping ancestor that
 * Floating UI's collision middleware resolves the trigger against — the Start-position popover in
 * particular already has a history of rendering as a sliver. Paying for three classes instead of
 * one keeps that failure mode off the table entirely.
 */
export const SEGMENT_FIRST_CLASS = 'h-full rounded-l-md rounded-r-none'
export const SEGMENT_CLASS = 'h-full rounded-none'
export const SEGMENT_LAST_CLASS = 'h-full rounded-r-md rounded-l-none'
